import { fromHex, } from "viem";

export declare type BlockHash = `0x${string}`;

export const isBlockHash = ( value: unknown ): value is BlockHash => {

	//TODO: check for bigint value is all zeros.

	return (
		typeof value === "string" && 
		value.startsWith("0x") && 
		value.length >= 42
	);
}
